import AnimSection from '../components/AnimSection';
import { PROJECTS, GALLERY_IMAGES } from '../data';

function GalleryRow({ images, direction }) {
  const loop = [...images, ...images];
  return (
    <div className="gallery-viewport">
      <div className={`gallery-track dir-${direction}`}>
        {loop.map((src, idx) => (
          <div className="gallery-item" key={`${src}-${idx}`}>
            <img src={src} alt="Elbot Automation project" decoding="async" />
          </div>
        ))}
      </div>
    </div>
  );
}

const PROJECT_IMAGES = {
  'Choco Stick Production Line': '/59.jpg',
  'ChocoPie Production Lines': '/26.jpg',
  'Chocolate Manufacturing Plant': '/66.jpeg',
  'Chocolate Handling System — Magnum Ice Cream': '/gallery/9.jpg',
  'Vicks Production Line': '/67.jpeg',
  'Aseptic Fruit Processing Technology': '/41.jpg',
  'Car Crash Testing Control Panel': '/48.jpg',
  'Energy Management System': '/68.jpeg',
  'Wheat Flour Conveying System Automation': '/51.jpg',
};

export default function Projects() {
  return (
    <div className="page-enter" style={{ paddingTop: '66px' }}>

      {/* ── PROJECT GALLERY ───────────────────── */}
      <div style={{ background: 'var(--dark)', padding: '3.5rem 0', position: 'relative', overflow: 'hidden' }}>
        <div className="grid-bg" style={{ position: 'absolute', inset: 0, opacity: .4 }} />
        <div className="sw" style={{ marginBottom: '2.2rem', position: 'relative', zIndex: 1 }}>
          <AnimSection>
            <div className="tag" style={{ marginBottom: '1rem' }}>Gallery</div>
            <h2 className="section-title" style={{ color: 'var(--white)', fontSize: 'clamp(1.8rem,3.5vw,2.6rem)', padding: 0 }}>
              Moments From The <span className="highlight">Shop Floor</span>
            </h2>
            <p style={{ color: 'rgba(255,255,255,.55)', maxWidth: '600px', lineHeight: 1.8, fontSize: '.95rem', marginTop: '1rem' }}>
              A glimpse into panel fabrication, on-site commissioning, and the engineering work behind every project we deliver.
            </p>
          </AnimSection>
        </div>

        <div style={{ position: 'relative', zIndex: 1 }}>
          <GalleryRow images={GALLERY_IMAGES} direction="left" />
        </div>
      </div>

      {/* ── PAGE HERO ─────────────────────────── */}
      <div style={{ background: 'var(--page-hero-soft)', padding: '5rem clamp(1.2rem,4vw,3rem) 4rem', borderBottom: '1px solid var(--border-1)', position: 'relative', overflow: 'hidden' }}>
        <div className="grid-bg" style={{ position: 'absolute', inset: 0 }} />
        <div style={{ position: 'absolute', right: '2%', top: '70%', transform: 'translateY(-50%)', fontFamily: 'var(--fH)', fontSize: 'clamp(6rem,12vw,10rem)', color: 'var(--accent-15)', letterSpacing: '4px', pointerEvents: 'none' }}>PORTFOLIO</div>
        <div className="sw" style={{ position: 'relative', zIndex: 1 }}>
          <div className="tag" style={{ marginBottom: '1rem' }}>Our Work</div>
          <h1 className="section-title" style={{ fontSize: 'clamp(2.4rem,5vw,4rem)', marginBottom: '1rem' }}>
            Delivered Large-Scale <span className="highlight">Projects</span>
          </h1>
          <p style={{ color: 'var(--mu)', maxWidth: '600px', lineHeight: 1.8, fontSize: '1.05rem' }}>
            A selection of successfully commissioned projects across food & beverage, pharmaceutical, automotive, and energy sectors — showcasing our end-to-end automation capabilities.
          </p>
        </div>
      </div>

      {/* ── STATS BAR ─────────────────────────── */}
      <div style={{ background: 'var(--dark)', padding: '2rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw" style={{ display: 'flex', justifyContent: 'space-around', textAlign: 'center', flexWrap: 'wrap', gap: '1.5rem' }}>
          {[
            { n: `${PROJECTS.length}+`, l: 'Major Projects' },
            { n: '6+', l: 'Industries Served' },
            { n: '8+', l: 'States Covered' },
            { n: '100%', l: 'On-Time Delivery' },
          ].map(s => (
            <div key={s.l}>
              <div style={{ fontFamily: 'var(--fH)', fontSize: '2rem', color: 'var(--o)', letterSpacing: '2px' }}>{s.n}</div>
              <div style={{ fontFamily: 'var(--fM)', fontSize: '.72rem', color: 'rgba(255,255,255,.6)', letterSpacing: '2px', textTransform: 'uppercase', marginTop: '.3rem' }}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── PROJECT CARDS ─────────────────────── */}
      <div style={{ background: 'var(--w2)', padding: '3rem clamp(1.2rem,4vw,3rem) 6rem' }}>
        <div className="sw">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '2rem' }}>
            {PROJECTS.map((p, i) => {
              const bgImage = PROJECT_IMAGES[p.title];
              const hasImage = Boolean(bgImage);
              return (
              <AnimSection key={p.title} delay={i * .07}>
                <div className="card project-card" style={{ padding: 0, overflow: 'hidden', height: '100%', display: 'flex', flexDirection: 'column' }}>

                  {/* Card Header */}
                  <div style={{ background: 'linear-gradient(135deg, var(--dark) 0%, #2a2220 100%)', padding: '2rem 2.2rem', position: 'relative' }}>
                    <div style={{ position: 'absolute', right: '1.5rem', top: '1.2rem', fontSize: '2.5rem', opacity: .3 }}>{p.image}</div>
                    <div style={{ display: 'flex', gap: '.6rem', flexWrap: 'wrap', marginBottom: '.8rem' }}>
                      <span className="chip" style={{ background: 'var(--accent-20)', color: 'var(--o2)', border: '1px solid var(--accent-30)', fontSize: '.68rem' }}>{p.year}</span>
                      <span className="chip" style={{ background: 'var(--white-8)', color: 'var(--white-70)', border: '1px solid var(--white-10)', fontSize: '.68rem' }}>{p.location}</span>
                    </div>
                    <h3 style={{ fontFamily: 'var(--fH)', fontSize: '1.25rem', letterSpacing: '1px', color: 'var(--white)', marginBottom: '.3rem', paddingRight: '2.5rem' }}>{p.title}</h3>
                    {p.client !== 'Confidential' && (
                      <div style={{ fontFamily: 'var(--fM)', fontSize: '.72rem', color: 'var(--accent-80)', letterSpacing: '2px', textTransform: 'uppercase' }}>Client: {p.client}</div>
                    )}
                  </div>

                  {/* Card Body */}
                  <div style={{
                    padding: '2rem 2.2rem',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundImage: hasImage ? `url(${bgImage})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative'
                  }}>
                    {/* Background overlay for image-backed cards */}
                    {hasImage && (
                      <div style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(255, 255, 255, 0.75)',
                        borderRadius: 'var(--r2)'
                      }} />
                    )}
                    <div style={{ position: 'relative', zIndex: 1 }}>
                      <p style={{ color: hasImage ? 'var(--dark)' : 'var(--mu)', fontWeight: hasImage ? 700 : 400, fontSize: '.9rem', lineHeight: 1.75, marginBottom: '1.5rem' }}>{p.desc}</p>

                      {/* Scope */}
                      <div style={{ marginBottom: '1.5rem' }}>
                        <div style={{ fontFamily: 'var(--fH)', fontSize: '.78rem', letterSpacing: '2px', color: 'var(--o)', marginBottom: '.7rem' }}>SCOPE OF WORK</div>
                        {p.scope.map(s => (
                          <div key={s} style={{ display: 'flex', gap: '.6rem', alignItems: 'flex-start', marginBottom: '.4rem' }}>
                            <span style={{ color: 'var(--o)', fontSize: '.75rem', marginTop: '2px', flexShrink: 0 }}>▸</span>
                            <span style={{ color: hasImage ? 'var(--dark)' : 'var(--d3)', fontWeight: hasImage ? 700 : 400, fontSize: '.85rem', lineHeight: 1.6 }}>{s}</span>
                          </div>
                        ))}
                      </div>

                      {/* Outcome */}
                      <div style={{ marginBottom: '1.5rem' }}>
                        <div style={{ fontFamily: 'var(--fH)', fontSize: '.78rem', letterSpacing: '2px', color: 'var(--o)', marginBottom: '.7rem' }}>OUTCOME</div>
                        {p.outcome.map(o => (
                          <div key={o} style={{ display: 'flex', gap: '.6rem', alignItems: 'flex-start', marginBottom: '.4rem' }}>
                            <span style={{ color: 'var(--o)', fontSize: '.75rem', marginTop: '2px', flexShrink: 0 }}>✓</span>
                            <span style={{ color: hasImage ? 'var(--dark)' : 'var(--d3)', fontWeight: hasImage ? 700 : 400, fontSize: '.85rem', lineHeight: 1.6 }}>{o}</span>
                          </div>
                        ))}
                      </div>

                      {/* Tags */}
                      <div style={{ display: 'flex', gap: '.4rem', flexWrap: 'wrap', marginTop: 'auto' }}>
                        {p.tags.map(t => (
                          <span key={t} className="chip" style={{ fontSize: '.68rem' }}>{t}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </AnimSection>
              );
            })}
          </div>
        </div>
      </div>

    </div>
  );
}
